import React from 'react'
import PropTypes from 'prop-types'
import managerApi from 'app/pipelines/checkout/manager'
import Progress from 'app/components/checkout/steps/partials/Progress'

export default class Header extends React.PureComponent {
  static get propTypes () {
    return {
      step: PropTypes.number,
      stepsCount: PropTypes.number,
      title: PropTypes.any,
      description: PropTypes.any,
      showIndex: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      step: 0,
      stepsCount: 0,
      title: null,
      description: null,
      showIndex: true
    }
  }

  close () {
    managerApi.close.dispatch()
  }

  renderIndex () {
    if (!this.props.showIndex) {
      return
    }

    return (
      <Progress step={this.props.step} total={this.props.stepsCount} />
    )
  }

  render () {
    const { title, description } = this.props

    return (
      <div className='step-header'>
        {this.renderIndex()}
        <div className='title-line'>
          <div className='title'>{title}</div>
          {this.props.children}
          <div onClick={this.close.bind(this)} className='close'>
            <div className='line-1' />
            <div className='line-2' />
          </div>
        </div>
        <div className='description'>{description}</div>
      </div>
    )
  }
}
